<template>
  <div class="toggle-button" @click="$emit('toggle')">
    <ui-button :icon="icon"></ui-button>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "QaListToggleButton",

  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.toggle-button {
  display: flex;
  align-items: center;
  gap: $spacing;
  color: $primary;
  margin-left: $spacing * 8.75;
  @include font-size(14px);
  cursor: pointer;
}
</style>
